import axiosClient from "api/axios_client.js";

const apiSendgridConfiguration = {
  create:         (payload)     => axiosClient.post("/email-management/email-settings/sendgrid-configuration/create", payload),
  update:         (id, payload) => axiosClient.put(`/email-management/email-settings/sendgrid-configuration/update/${id}`, payload),
  getAll:         (payload)     => axiosClient.post("/email-management/email-settings/sendgrid-configuration/get-all", payload),
  getAllData:      ()            => axiosClient.get("/email-management/email-settings/sendgrid-configuration/get-all"),
  getById:        (id)          => axiosClient.get(`/email-management/email-settings/sendgrid-configuration/get-by-id/${id}`),
  delete:         (id)          => axiosClient.delete("/email-management/email-settings/sendgrid-configuration/delete", { data: { id } }),

  getCredentials:      ()                        => axiosClient.get("/email-management/email-settings/sendgrid-credential/get-all"),
  testConfiguration:   (id, test_email)          => axiosClient.post("/email-management/email-settings/sendgrid-configuration/test-configuration", { id, test_email }),
};

export default apiSendgridConfiguration;
